// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31YXM","type":"styles_type__2iFYM","choices":"styles_choices__1ufCf"};